import qs from 'querystring'

/**
 * 深复制对象
 * @param obj {Object} 被拷贝的对象
 * @returns {Object}
 */
export function deepClone (obj) {
  if (!isObject(obj)) {
    throw new Error('obj 不是一个对象！')
  }

  let isArray = Array.isArray(obj)
  let cloneObj = isArray ? [] : {}
  for (let key in obj) {
    cloneObj[key] = isObject(obj[key]) ? deepClone(obj[key]) : obj[key]
  }
  return cloneObj
}

// 判断是否为对象
export function isObject (o) {
  return (typeof o === 'object' || typeof o === 'function') && o !== null
}

// 获取页面 location query 参数
export function getQuery (name, url = window.location.hash) {
  const queries = url.substr(url.indexOf('?') + 1)
  const params = qs.parse(queries)
  return name ? params[name] : params
}

// scrollTop animation
/**
 * 滚动到窗口顶部动画
 * @param el          滚动元素
 * @param from        起始位置，距顶部距离，卷曲距离 scrollTop
 * @param to          终止位置，距顶部距离，卷曲距离 scrollTop
 * @param duration    动画持续时间
 * @param endCallback 动画执行完毕回调
 */
export function scrollTop (el, from = 0, to, duration = 500, endCallback) {
  // requestAnimationFrame 兼容
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = (
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback) {
        return window.setTimeout(callback, 1000 / 60)
      }
    )
  }
  const difference = Math.abs(from - to)
  const step = Math.ceil(difference / duration * 50)

  function scroll (start, end, step) {
    if (start === end) {
      endCallback && endCallback()
      return
    }

    let d = (start + step > end) ? end : start + step
    if (start > end) {
      d = (start - step < end) ? end : start - step
    }

    if (el === window) {
      window.scrollTo(d, d)
    } else {
      el.scrollTop = d
    }
    window.requestAnimationFrame(() => scroll(d, end, step))
  }
  scroll(from, to, step)
}

export function formatTreeData (arr) {
  // if no arr, return
  if (!Array.isArray(arr)) return
  arr.forEach((el) => {
    el.title = el.file_name
    el.children = el.son
    // 如果是根目录，默认展开
    if (!el.parent_id) {
      el.expand = true
    }
    if (el.son && el.son.length > 0) {
      formatTreeData(el.son)
    }
  })
  return arr
}
/**
 *
 * @param {文件格式} fileType
 */
function isImage (fileType) {
  if (!fileType || typeof fileType !== 'string') return
  if (fileType === 'jpg' || fileType === 'jpeg' || fileType === 'png' || fileType === 'gif') {
    return true
  } else {
    return false
  }
}
function isVideo (fileType) {
  if (!fileType || typeof fileType !== 'string') return
  if (fileType === 'mp4' || fileType === 'mov') {
    return true
  } else {
    return false
  }
}
/**
 *
 * @param {需要设置是否是图片的对象或者数组} params
 * 文件格式默认字段：file_type
 */
export function setImgFlag (params) {
  if (Array.isArray(params)) {
    params.forEach((item) => {
      item.file_type = item.file_type.toLowerCase()
      if (isImage(item.file_type)) {
        item.isImg = true
        item.isVideo = false
      } else if (isVideo(item.file_type)) { // 是否是视频
        item.isImg = false
        item.isVideo = true
      } else {
        item.isImg = false
        item.isVideo = false
      }
    })
  } else {
    params.file_type = params.file_type.toLowerCase()
    if (isImage(params.file_type)) {
      params.isImg = true
      params.isVideo = false
    } else if (isVideo(params.file_type)) {
      params.isImg = false
      params.isVideo = true
    } else {
      params.isImg = false
      params.isVideo = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/js/utils.js